import { render, staticRenderFns } from "./RegisterHeader.vue?vue&type=template&id=75a21836&scoped=true&"
import script from "./RegisterHeader.vue?vue&type=script&lang=js&"
export * from "./RegisterHeader.vue?vue&type=script&lang=js&"
import style0 from "./RegisterHeader.vue?vue&type=style&index=0&id=75a21836&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a21836",
  null
  
)

export default component.exports